import { Link } from "gatsby";
import React, { FunctionComponent, MouseEvent } from "react";
import useAuthModal from "../../hooks/useAuthModal";
import { AuthLinkProps } from "../../interfaces/interfaces";
import useModalStore from "../../store/useModalStore";

const AuthLink: FunctionComponent<AuthLinkProps> = ({
  to,
  children,
  closeNav,
  ...props
}) => {
  // const openModal = useModalStore((state) => state.openModal);
  const { openModal } = useModalStore();
  const { user } = useAuthModal();

  const handleOnClick = (event: MouseEvent) => {
    if (!user) {
      event.preventDefault();
      openModal();
    }

    // Consider moving closeNav to context so to not have to send down as prop
    if (closeNav) {
      closeNav();
    }
  };

  return (
    <Link
      to={to}
      target={props.target}
      onClick={handleOnClick}
      className={props.className}
    >
      {children}
    </Link>
  );
};

export default AuthLink;
